export const navigateUp = (path: string, times = 1) => {
  const timesToSlice = path.endsWith('/') ? times + 1 : times

  return path
    .split('/')
    .slice(0, -1 * timesToSlice)
    .join('/')
}
